import BreadcrumbLink from "../common/breadcrumb";

const TopSection = (props) => {
    const cardTitle = props?.cardTitle || "";

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    justifyContent: props?.compact ? "flex-start" : "space-between",
                    alignItems: props?.compact ? "center" : undefined,
                    fontSize: 13,
                    padding: props?.compact ? '2px 0px' : '20px 0px 10px 0px',
                    marginTop: props?.compact ? '-1px' : undefined,
                    marginLeft: '10px'
                }}
            >
                <div>
                    <BreadcrumbLink breadcrumbArray={ props?.breadcrumbArray } count={props.count} />
                </div>

            </div>
            {!props.hideTitle && <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    fontSize: 13,
                    fontWeight: "bold",
                    padding: '0px 0px 20px 0px',
                }}
            >
                {props.hideHeader ? <div>{props.headerName}</div> : <div>{cardTitle} - {props?.tabTitle}</div>}
            </div>}

        </div>
    )
}

export default TopSection;